module.exports = __webpack_public_path__ + "img/banner-39.adcd1e2f.jpg";